export default "__VITE_ASSET__D8N84dwX__"